import script from "./PageBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./PageBreadcrumb.vue?vue&type=style&index=0&id=5f632c83&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f632c83"]])

export default __exports__